AFRAME.registerComponent('top-menu-controls', {
    schema: {},
    init: function () {
        console.log('[top-menu-controls] Initializing...');
        this.createTopLevelButtons();
        this.createSpecialButtons();
        this.createComingSoonButtons();
        this.attachButtonListeners();

        this.onThemeChanged = this.onThemeChanged.bind(this);
        this.el.sceneEl.addEventListener('theme-changed', this.onThemeChanged);

        setTimeout(() => {
            let themeMode = 'Dark';
            if (typeof getCacheItem === 'function') {
                const mainSettings = getCacheItem('mainSettings');
                if (mainSettings && mainSettings.themeMode) {
                    themeMode = mainSettings.themeMode;
                }
            }
            this.updateTooltipTheme(themeMode);
        }, 200);
    },

    remove: function () {
        if (this.onThemeChanged && this.el && this.el.sceneEl) {
            this.el.sceneEl.removeEventListener('theme-changed', this.onThemeChanged);
        }
    },

    onThemeChanged: function (e) {
        this.updateTooltipTheme(e && e.detail ? e.detail.themeMode : 'Dark');
    },

    updateTooltipTheme: function (themeMode) {
        const isLight = themeMode === 'Light';
        const bgColor = isLight ? '#FFFFFF' : '#111111';
        const textColor = isLight ? '#14141C' : '#FFFFFF';

        const backgrounds = this.el.querySelectorAll('.vr-comingsoon-tooltip-bg');
        backgrounds.forEach((bg) => {
            bg.setAttribute('rounded-box', 'color', bgColor);
        });

        const texts = this.el.querySelectorAll('.vr-comingsoon-tooltip-text');
        texts.forEach((text) => {
            text.setAttribute('color', textColor);
        });
    },

    attachButtonListeners: function () {
        const watchlistBtn = document.querySelector('#watchlist-button');
        if (watchlistBtn) {
            watchlistBtn.addEventListener('click', () => {
                console.log('Watchlist button clicked');
                if (window.PopupManager) {
                    window.PopupManager.open('edit-watchlist-popup');
                } else {
                    const popup = document.querySelector('#edit-watchlist-popup');
                    if (popup && popup.components['edit-watchlist']) {
                        popup.components['edit-watchlist'].open();
                    }
                }

                if (window.gtag) gtag('event', `VR_TopNav_WatchlistEdit`);
            });
        }
    },

    createTopLevelButtons: function () {
        const buttonsList = [
            { label: 'Home', posX: -0.1, isActive: true },
            { label: '3D Chart', posX: 0.22, isActive: true },
            { label: 'Plots', posX: 0.5 },
            { label: 'River', posX: 0.75 },
            { label: 'News', posX: 1.02 },
            { label: 'Compare', posX: 1.3 },
        ]
        const y = 0.06 
        const z = 0.01;
        
        buttonsList.forEach((properties, index) => {
            const buttonText = document.createElement('a-text');
            buttonText.setAttribute('position', `${properties.posX} ${y} ${z}`)
            buttonText.setAttribute('rotation', `30 0 0`)
            buttonText.setAttribute('value', properties.label)
            buttonText.setAttribute('scale', '0.22 0.22 0.22')
            buttonText.setAttribute('align', 'center')
            buttonText.setAttribute('color', properties.isActive ? '#fff' : '#666')
            if (properties.isActive) buttonText.classList.add('top-level-text-active');
            if (properties.canBeActive) buttonText.classList.add('top-level-text-can-be-active');
            // buttonText.classList.add('chart-type-title')
            this.el.appendChild(buttonText);
        })
        
    },

    createSpecialButtons: function () {
        // Home
        const btnHome = document.createElement('a-plane');
        btnHome.setAttribute('width', 0.3);
        btnHome.setAttribute('height', 0.14);
        btnHome.setAttribute('position', '-0.1 0.06 0.025');
        btnHome.setAttribute('rotation', '30 0 0');
        btnHome.setAttribute('data-raycastable', '');
        btnHome.setAttribute('class', 'clickable');
        btnHome.setAttribute('opacity', '0');
        btnHome.addEventListener('click', () => {
            const scene = this.el.sceneEl;
            if (scene && scene.exitVR) {
                scene.exitVR();
            }
            let url = '/index.html?source=vis-platform';
            window.open(url);
        });
        this.el.appendChild(btnHome);
        
        // 3D Chart
        const btn3DChart = document.createElement('a-plane');
        btn3DChart.setAttribute('width', 0.3);
        btn3DChart.setAttribute('height', 0.14);
        btn3DChart.setAttribute('position', '0.22 0.06 0.025');
        btn3DChart.setAttribute('rotation', '30 0 0');
        btn3DChart.setAttribute('data-raycastable', '');
        btn3DChart.setAttribute('class', 'clickable');
        btn3DChart.setAttribute('opacity', '0');
        btn3DChart.addEventListener('click', () => {
            this.exitSearchModeWithChecker();
            
            if (window.WatchlistApp && window.WatchlistApp.Manager && typeof window.WatchlistApp.Manager.clearWatchlistData === 'function') {
                window.WatchlistApp.Manager.clearWatchlistData(true);
            }

            const defaultChartPlane = document.querySelector('#top-menu-container a-plane.default-chart');
            if (defaultChartPlane) {
                defaultChartPlane.click();
            }

            const rightContainer = document.getElementById('right-container');
            if (rightContainer && rightContainer.components['right-container-control']) {
                rightContainer.components['right-container-control'].initializeDefaultChart();
            }

            this.el.sceneEl.emit('news-filter-changed', { filter: 'general' });
            this.el.sceneEl.emit('set-news-filter-ui', { filter: 'general' });
        });
        this.el.appendChild(btn3DChart);

        console.log('[top-menu-controls] "3D Chart" interactive plane created.');
    },
    
    exitSearchModeWithChecker: function () {
        console.log('[top-menu-controls] "3D Chart" clicked.');
        const searchPanel = document.querySelector('#search-center-panel');
        if (!searchPanel || searchPanel.getAttribute('visible') === 'false' || searchPanel.getAttribute('visible') === false) {
            console.log('[top-menu-controls] Search panel hidden, ignoring exit click.');
            return;
        }

        const searchModeEntity = document.querySelector('[search-mode]');
        if (searchModeEntity && searchModeEntity.components['search-mode']) {
            searchModeEntity.components['search-mode'].exitSearchMode();
        } else {
            console.warn('[top-menu-controls] search-mode component not found.');
        }
    },

    createComingSoonButtons: function () {
        const step = 0.24;
        const baseX = 0.29;
        const configs = [
            { label: 'Plots',   x: baseX + step * 1 },
            { label: 'River',   x: baseX + step * 2 },
            { label: 'News',    x: baseX + step * 3 },
            { label: 'Compare', x: baseX + step * 4 },
        ];

        configs.forEach(({ label, x }) => {
            const hitbox = document.createElement('a-plane');
            hitbox.setAttribute('width', 0.22);
            hitbox.setAttribute('height', 0.14);
            hitbox.setAttribute('position', `${x.toFixed(2)} 0.08 0.12`);
            hitbox.setAttribute('opacity', '0');
            hitbox.setAttribute('data-raycastable', '');
            hitbox.setAttribute('data-label', label);

            const tooltipEl = document.createElement('a-entity');
            tooltipEl.setAttribute('visible', false);
            tooltipEl.setAttribute('position', '0 0.11 0.01');

            const tooltipBg = document.createElement('a-entity');
            tooltipBg.classList.add('vr-comingsoon-tooltip-bg');
            tooltipBg.setAttribute('rounded-box', {
                width: 0.33,
                height: 0.10,
                depth: 0.01,
                radius: 0.015,
                color: '#111111',
                opacity: 1,
                cornerstyle: 'ext'
            });

            const tooltipText = document.createElement('a-troika-text');
            tooltipText.classList.add('vr-comingsoon-tooltip-text');
            tooltipText.setAttribute('value', 'Coming soon');
            tooltipText.setAttribute('font-size', 0.038);
            tooltipText.setAttribute('align', 'center');
            tooltipText.setAttribute('anchor', 'center');
            tooltipText.setAttribute('baseline', 'center');
            tooltipText.setAttribute('position', '0 0 0.006');
            tooltipText.setAttribute('color', '#FFFFFF');

            tooltipEl.appendChild(tooltipBg);
            tooltipEl.appendChild(tooltipText);
            hitbox.appendChild(tooltipEl);

            hitbox.addEventListener('mouseenter', () => {
                tooltipEl.setAttribute('visible', true);
            });
            hitbox.addEventListener('mouseleave', () => {
                tooltipEl.setAttribute('visible', false);
            });

            this.el.appendChild(hitbox);
        });
    }
});
